import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { GlobalHelper } from '@app/_shared/_helpers/global.helper';
import { user } from '@app/_shared/_models/user';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { ForumCllajService } from '@app/_shared/_services/forum/cllaj.service';
import { ForumEvenementService } from '@app/_shared/_services/forum/evenement.service';
import { ForumInscriptionService } from '@app/_shared/_services/forum/inscription.service';
import { MailService } from '@app/_shared/_services/mail.service';
import { UsersService } from '@app/_shared/_services/users.service';
import { environment } from '@environments/environment';
import { Options } from 'ngx-qrcode-styling';
import * as _ from "underscore"
declare var _smartsupp;

@Component({
  selector: 'app-cllajinscription2',
  templateUrl: './cllajinscription2.component.html',
  styleUrls: ['./cllajinscription2.component.scss']
})
export class Cllajinscription2Component implements OnInit {

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('resultFinal',{static:false}) resultFinal: ElementRef;
  lieux = [];
  parts = []

  subscriptions: any = [];
  currentUser: user;
  finalForm;
  saving: boolean = false;
  canContinue: boolean = false;

  cllajInscription;
  cllajUrl

  qrCodeConfig
  hasQrCode = false;
  lastStep = 2
  constructor(
    public authenticationService: AuthenticationService,
    public inscriptionService: ForumInscriptionService, private evenementService: ForumEvenementService,
    private usersService: UsersService,
    private cllajService: ForumCllajService
    , private mailService: MailService, private globalHelper:GlobalHelper
    ) {
    this.subscriptions.push(
      this.authenticationService.currentUser.subscribe(
        (x) => {
          this.currentUser = x;
          if (this.currentUser)
            this.inscriptionService.form.idUser = this.currentUser.id
        }
      )
    );
  }

  // @HostListener('window:popstate', ['$event'])
  // onPopState(event: any) {
  //   // Votre logique de traitement ici
  //   // ...
  //   history.go(1);
  //   alert("If you go back to the previous page, please back from the return to the previous button.");
  // }

  ngOnDestroy() {
    _.each(this.subscriptions, (sub) => sub.unsubscribe());
  }

  async ngOnInit(): Promise<void> {

    if(!this.evenementService.selectedItem)
      await  this.evenementService.getItems({active:true}).toPromise().then(res=>{ this.evenementService.setSelectedItem(res.items[0])})
    if(this.evenementService.selectedItem?.evenementParts)
      this.parts = _.filter(this.evenementService.selectedItem?.evenementParts, ep =>!ep.childrens && ep.descriptionHtml) /* and visible in home */
    if(this.parts)
      this.parts = _.sortBy(this.parts, l => l.ordre)
    if(this.evenementService.selectedItem?.evenementLieux)
      this.lieux = this.evenementService.selectedItem?.evenementLieux
    if(this.lieux)
      this.lieux = _.sortBy(this.lieux, l => l.dateDebut)


    this.cllajUrl = environment.cllajUrl
    if (this.inscriptionService.form.step == this.lastStep) {
      this.inscriptionService.clearFormSessionStorage()
    }
    this.inscriptionService.refreshFormSessionStorage();
    this.evenementService.getItems({ where: { active: true } }).subscribe(res => {
      if (res.items?.length) {
        this.evenementService.setSelectedItem(res.items[0])
        this.inscriptionService.form.idEvenement = res.items[0].id
        this.canContinue = true;
      }
    })
    if (this.currentUser)
      this.inscriptionService.form.idUser = this.currentUser.id

    if (!this.inscriptionService.form.step)
      this.inscriptionService.form.step = 1

    // if (this.inscriptionService.form.step == this.lastStep)
    //   this.checkCllajInscription()
  }

  // pushHistoryState(step) {
  //   const stateObject = { };
  //   const title = 'Inscription Etape ' + step;

  //   this.location.getState(); // Obtenez l'état actuel
  //   this.location.pushState(stateObject, title, 'nouvelle-url');
  // }
  goPart2(form) {
    // add history state
    this.goPartFinal(form)
      }
      goPart3(form) {
    // add history state



        this.inscriptionService.form.step = 3;
      }
  goPartFinal(form) {
    // save
    // scan url : window?.location.protocol + '//' + window?.location.host + '/inscription/detail/' + inscription.id
    if (!this.saving) {
      this.saving = true;
      this.save().then((inscription:any) => {
        console.log('inscription', inscription)
        this.qrCodeConfig = {
          width: 300,
          height: 300,
          // data: 'inscriptionForum:'+inscription.id,
          data: window?.location.protocol + '//' + window?.location.host + environment.baseHref + '/forum/inscription/detail/' + inscription.id,
          image:  "assets/images/2023/logo-mobile.png",
          imageOptions:{"hideBackgroundDots":true,"imageSize":0.4,"margin":0},
          margin: 5,
          qrOptions:{typeNumber:0,"mode":"Byte","errorCorrectionLevel":"Q"},
          dotsOptions: {
            type:"extra-rounded",color:"#000000"
          },
          cornersSquareOptions:{"type":"extra-rounded","color":"#000000"},
          cornersDotOptions:{color:"#000000"},

          backgroundOptions: {
            color: "#ffffff",
          },
        };
        console.log('qrCodeConfig', this.qrCodeConfig)
        this.hasQrCode = true;
        this.inscriptionService.form.step = 2;
        this.hasP = this.checkHasP()
        this.hasSP = this.checkHasSP()
        this.hasD = this.checkHasD()
        this.selectedActivites = this.getActivites()
        setTimeout(() => {
        console.log('this.finalForm.salons.selectedItems',this.finalForm.salons.selectedItems)
          // add atelier
          // if(this.hasSP()){
          //   // home dating
          //   this.cllajService.addAtelier({user_id: this.currentUser.id,atelier_id:555}).subscribe(res => {})
          // }
          // if(this.hasD()){
          //   // offres
          //   this.cllajService.addAtelier({user_id: this.currentUser.id,atelier_id:556}).subscribe(res => {})
          // }
          // if(this.hasP()){
          //   // activites
          //   this.cllajService.addAtelier({user_id: this.currentUser.id,atelier_id:554}).subscribe(res => {})
          // }
          // this.usersService.saveItem({id:this.currentUser.id,idCllaj:inscription.id}).subscribe(res => {})

          console.log('this.finalForm',this.finalForm)
          // Convert canvas innerHTML to img tag
          let canvasElement = document.getElementsByTagName('canvas')[0] as HTMLCanvasElement; // Replace 'yourCanvasId' with the actual ID of your canvas element
          let qrcodeSrc = canvasElement.toDataURL(); // Convert canvas to data URL
          console.log('qrcodeSrc',qrcodeSrc)
          // send mail with mailService, the mail content will be html from dom, element id is #resultfinal
          let to = this.currentUser.email;
          let html = this.resultFinal.nativeElement.innerHTML;
          let imgSrc =  window.location.protocol+'//'+window.location.host + environment.baseHref +'/assets/images/2023/logo.png' // await this.globalHelper.convertImageToBase64('/assets/images/2023/logo.png');

          html = '<div class="text-center m-b-30 logo"><img  src="'+ imgSrc + '" style="max-height: 115px;" /></div>' + html;


          let qrCodeAttachment = {filename:'qrcode.png',content:qrcodeSrc.split("base64,")[1],encoding:'base64',cid:'qrCode'};
          html += `<h3>Présente ton QR Code à l'entrée du Forum D’Clic Jeune 2025</h3>
          <div class="text-center m-b-30 qrcode"><img  src="cid:qrCode" style="width:300px;height:300px;" /></div>` ;

          let text = this.resultFinal.nativeElement.textContent;
          let subject = "Qr Code Invitation au Forum D'Clic Jeune 2025"
          this.mailService.sendMail(to, subject,text,html,null,null,[qrCodeAttachment]).subscribe(res => {
            console.log('mail sent')
          })

          window.scrollTo(0, 0);
        this.saving = false;
      }, 1000);
      }).catch(err => {
        window.scrollTo(0, 0);
        this.saving = false;
      })
    }
    // this.inscriptionService.form.step = 3;
  }
  prevStep() {
    if (this.inscriptionService.form.step > 1)
      this.inscriptionService.form.step = this.inscriptionService.form.step--;
  }
  goPart1() {
    this.inscriptionService.form.step = 1;
  }

  // goPart4(){
  //   // save
  //   if(!this.saving){
  //     this.saving = true;
  //   this.save().then(()=>{
  //     this.inscriptionService.form.step = 4;
  //     this.saving = false;
  //   }).catch(err =>{
  //     this.saving = false;
  //   })
  // }
  // }
  save() {
    return new Promise<void>((resolve, reject) => {

      this.inscriptionService.saveInscription().subscribe(res => {
        console.log('inscription ok', res)
        this.finalForm = _.clone(this.inscriptionService.form)
        this.inscriptionService.clearFormSessionStorage()
        resolve(res)
      }, err => reject(err))
    })
  }
  close() {
    this.onClose.emit()
  }

  // check cllaj inscription with CllajService
  checkCllajInscription() {
      return this.cllajService.verifyInscription(this.finalForm.user.email).toPromise().then(res => {
        this.cllajInscription = res;
        // console.log(this.cllajInscription)
        return this.cllajInscription;
      }).catch(err => { return null; })
  }

  hasInscriptionAndDemande() {
    return this.currentUser && this.currentUser?.demandeLogements?.length > 0
  }
  hasInscriptionOnly() {
    return this.currentUser &&  !this.currentUser?.demandeLogements?.length
  }

  hasNoInscription() {
    return !this.currentUser;
  }

  hasSP:boolean = false;
  checkHasSP(){
    return _.find(this.finalForm.salons.selectedItems, item => item.type.indexOf("home_dating") > -1 && !item.idParent);
  }

  hasD:boolean = false;
  checkHasD(){
    return _.find(this.finalForm.salons.selectedItems, item => item.type.indexOf("petitsalon_delivrance") > -1 && !item.idParent);

  }

  hasP:boolean = false;
  checkHasP(){
    return _.find(this.finalForm.salons.selectedItems, item => item.type.indexOf("petitsalon_activites") > -1 && !item.idParent);
  }
  selectedActivites:any[] = [];
getActivites(){
  console.log('getActivites',this.finalForm.salons.selectedItems)
    return _.sortBy(_.filter(this.finalForm.salons.selectedItems, item => item.type.indexOf("petitsalon_activites") > -1 && item.idParent), f => f.ordre) /*.map(item =>
    {
        if(item.idParent && !item.parent)
          item.parent = _.find(this.parts, part => part.id == item.idParent)
        return item
    })*/;
}


}
